enum CustomEvent {
  INSTALL_CLICK = 'install_button_click',
}

interface CustomEventsParamsMap {
  [CustomEvent.INSTALL_CLICK]: InstallClickParams;
}

export interface PageViewParams {
  wix_referring_page: string | undefined;
  wix_referring_page_details: string | undefined;
  app_position_in_source: string | undefined;
}

export interface DefaultParams {
  send_to: string;
  deviceType: 'desktop' | 'mobile';
  app_market_platform: string;
  wix_user_id?: string;
  wix_site_id?: string;
  premium_wix_site?: boolean;
}

interface InstallClickParams {}

export { CustomEvent, CustomEventsParamsMap };
